import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clipPath="url(#clip0_6007_4025)">
        <g filter="url(#filter0_d_6007_4025)">
          <path
            d="M8.57129 9.07867V50.9214C8.57129 53.0195 10.4932 54.7253 12.857 54.7253H47.1427C49.5066 54.7253 51.4284 53.0195 51.4284 50.9214V9.07867C51.4284 6.98059 49.5066 5.27478 47.1427 5.27478H12.857C10.4932 5.27478 8.57129 6.98059 8.57129 9.07867ZM40.7141 12.8826H19.2856C18.1003 12.8826 17.1427 12.0326 17.1427 10.9806C17.1427 9.9286 18.1003 9.07867 19.2856 9.07867H40.7141C41.8994 9.07867 42.857 9.9286 42.857 10.9806C42.857 12.0326 41.8994 12.8826 40.7141 12.8826Z"
            fill="#33373F"
          />
          <path
            d="M8.85129 50.9214V9.07867C8.85129 7.16568 10.6155 5.55478 12.857 5.55478H47.1427C49.3842 5.55478 51.1484 7.16568 51.1484 9.07867V50.9214C51.1484 52.8344 49.3842 54.4453 47.1427 54.4453H12.857C10.6155 54.4453 8.85129 52.8344 8.85129 50.9214ZM19.2856 13.1626H40.7141C42.0217 13.1626 43.137 12.2177 43.137 10.9806C43.137 9.7435 42.0217 8.79867 40.7141 8.79867H19.2856C17.978 8.79867 16.8627 9.7435 16.8627 10.9806C16.8627 12.2177 17.978 13.1626 19.2856 13.1626Z"
            stroke="#7E8187"
            strokeWidth="0.56"
          />
        </g>
        <mask
          id="mask0_6007_4025"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="9"
          y="5"
          width="42"
          height="50"
        >
          <rect x="9" y="5" width="42" height="50" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6007_4025)">
          <path
            d="M53.2246 37.8435C53.2246 41.5343 50.5178 44.8969 46.0947 47.3427C41.675 49.7865 35.5625 51.3012 28.8054 51.3012C22.0482 51.3012 15.9357 49.7865 11.516 47.3427C7.09288 44.8969 4.38613 41.5343 4.38613 37.8435C4.38613 34.1527 7.09288 30.79 11.516 28.3442C15.9357 25.9004 22.0482 24.3858 28.8054 24.3858C35.5625 24.3858 41.675 25.9004 46.0947 28.3442C50.5178 30.79 53.2246 34.1527 53.2246 37.8435Z"
            stroke="#464A50"
            strokeWidth="0.2"
          />
        </g>
        <ellipse
          cx="30.0007"
          cy="37.5413"
          rx="13.2692"
          ry="7.78846"
          fill="#2A2D34"
        />
        <path
          d="M22.3643 21.449L30.9386 17.2971C31.0731 17.1969 31.2361 17.1428 31.4036 17.1428C31.5711 17.1428 31.7342 17.1969 31.8687 17.2971C32.1777 17.5045 32.3828 17.7119 32.3828 18.1295V38.863C32.3828 39.2748 32.3828 39.3778 32.2803 39.5852C32.1777 39.6882 32.0752 39.8956 31.9726 39.8956C31.7661 39.9985 31.5596 39.9985 31.1437 39.9985H21.1309C20.7193 39.9985 20.6181 39.9985 20.4116 39.8956C20.3091 39.7912 20.1025 39.6882 20.1025 39.5852C20 39.3807 20 39.2763 20 38.8644V25.7967C20 24.6554 20.1025 24.3451 20.2051 23.8288C20.3091 23.4155 20.5142 22.9964 20.8232 22.6875C21.1309 22.3771 21.44 22.0683 22.3658 21.4475L22.3643 21.449ZM24.948 26.5261C24.5378 26.5261 24.1191 26.9395 24.1191 27.5645C24.1191 28.1852 24.5321 28.6042 24.948 28.6042H27.4291C27.8407 28.6042 28.2581 28.1894 28.2581 27.5645C28.2581 26.9452 27.845 26.5261 27.4291 26.5261H24.948ZM24.948 29.6368C24.6404 29.6368 24.4352 29.8428 24.2287 30.1517C24.1257 30.4905 24.1257 30.8526 24.2287 31.1914C24.2817 31.341 24.379 31.4706 24.5076 31.563C24.6362 31.6553 24.7899 31.7058 24.948 31.7077H27.4291C27.8407 31.7077 28.2581 31.2944 28.2581 30.6694C28.2581 30.0501 27.845 29.6297 27.4291 29.6297H24.948L24.948 29.6368ZM24.948 33.7844C24.5378 33.7844 24.1191 34.1991 24.1191 34.8241C24.1191 35.4491 24.5321 35.8624 24.948 35.8624H27.4291C27.8407 35.8624 28.2581 35.4491 28.2581 34.8241C28.2581 34.1991 27.845 33.7858 27.4291 33.7858H24.948L24.948 33.7844ZM35.8923 22.6861C35.7667 22.5761 35.6155 22.4996 35.4528 22.4636C35.29 22.4276 35.1208 22.4333 34.9608 22.4801C34.6517 22.5845 34.4467 22.8949 34.4467 23.3125V38.8644C34.4467 39.2763 34.4467 39.3793 34.5492 39.5866C34.6517 39.7926 34.7543 39.7926 34.8583 39.897C34.9608 40 35.1659 40 35.475 40H37.5431C37.9561 40 38.0573 40 38.1612 39.897L38.4689 39.5866C38.5714 39.4837 38.5714 39.2763 38.5714 38.8644V27.7704C38.5714 26.835 38.5714 26.5261 38.4689 26.2143C38.3663 25.9054 38.2638 25.5951 38.0573 25.279C37.8521 24.9701 37.7496 24.7641 37.1258 24.0347L35.8923 22.6861Z"
          fill="#6D7380"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6007_4025"
          x="3.57129"
          y="2.27478"
          width="52.8574"
          height="59.4506"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_4025"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_4025"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6007_4025">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
